import { render, staticRenderFns } from "./RiderList.vue?vue&type=template&id=0ac81ccc&scoped=true"
import script from "./RiderList.vue?vue&type=script&lang=js"
export * from "./RiderList.vue?vue&type=script&lang=js"
import style0 from "./RiderList.vue?vue&type=style&index=0&id=0ac81ccc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac81ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac81ccc')) {
      api.createRecord('0ac81ccc', component.options)
    } else {
      api.reload('0ac81ccc', component.options)
    }
    module.hot.accept("./RiderList.vue?vue&type=template&id=0ac81ccc&scoped=true", function () {
      api.rerender('0ac81ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryInfo/RiderList.vue"
export default component.exports